module.exports = __webpack_public_path__ + "static/6-b06af05dd9840b846b1ac8000eba1fe0.jpeg";